import { render, staticRenderFns } from "./VideoPreview.vue?vue&type=template&id=c11808aa"
import script from "./VideoPreview.vue?vue&type=script&lang=js"
export * from "./VideoPreview.vue?vue&type=script&lang=js"
import style0 from "./VideoPreview.vue?vue&type=style&index=0&id=c11808aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports